
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Permission } from "app/shared/auth/permission.enum";
import { Observable } from "rxjs";

export abstract class AbGrupoPessoa extends AppService {

  abstract desativarGrupoPessoa(id: number);
  abstract getAllGrupoPessoas(filter: AppFilter);
  abstract getAllGrupoAtivos();
  abstract salvar(grupoPessoa): Observable<any>;
  abstract getById(id: number);
  abstract getByIdForSigma(id: number);
  abstract getGruposPermissao(permissao: Permission);
  abstract getGruposPermissaoPromise(permissao: Permission);
  abstract getTipoPerfis();
  abstract getSigmaGrupoAcesso();
  abstract getPublicSigmaGrupoAcesso();

}
